var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#17BF88",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-359 -825) translate(360 826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.543C2.976 2.181 6.518 0 10.624 0c4.106 0 7.723 2.181 10.85 6.543-2.979 3.9-6.595 5.851-10.85 5.851S2.828 10.444 0 6.543z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 6.3,
    r: 5.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon-view.3b12c77d1e7ccea6300ccf5bac1b1b6e.svg";
export { ForwardRef as ReactComponent };